import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import router from './router';
import * as Sentry from '@sentry/vue';
import { IonicVue } from '@ionic/vue';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';
/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';
/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';
/* Theme variables */
// import './theme/variables.css';
import './theme/gardxgroup.css';
/* registerServiceWorker to cache assets if offline/slow network */
import './registerServiceWorker';
/* Google Tag Manager */
import './composables/gtm.js';
import { configurationProblems } from './services/backend';

/*
 * Migration: the portal talks to both backends while it moves across, one area at a time, driven
 * by VUE_APP_VAPCORE_ENDPOINTS. A mistake in that list surfaces here rather than as an
 * unexplained failure on whichever screen happens to use the misconfigured area.
 */
configurationProblems().forEach((problem) => {
  console.error(`[migration] ${problem}`);
  Sentry.captureMessage(`Backend configuration: ${problem}`);
});

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App).use(IonicVue).use(router).use(pinia);
/* Initiate Sentry monitoring & error tracking */
Sentry.init({
  app,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  environment: process.env.VUE_APP_ENV,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.4,
  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [],
  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

router.isReady().then(() => {
  app.mount('#app');
});

defineCustomElements(window);
